import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Rating from "@mui/material/Rating";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import TextField from "@mui/material/TextField";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { Box, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  scoreSubtitlesApi,
  addCommemtApi,
  getSubtitlesCommentsApi,
} from "../../../../../services/subtitlesApi";
import Divider from "@mui/material/Divider";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function OneSubtitleDetails(props) {
  const { oneRowSubtitle, indexSubtitle } = props;
  const [expanded, setExpanded] = React.useState(false);
  const [subtitlesScoreValue, setSubtitlesScoreValue] = React.useState(
    oneRowSubtitle[0]["subtitlesScoreValue"] || 0
  );
  const [subtitlesScoreCount, setSubtitlesScoreCount] = React.useState(
    oneRowSubtitle[0]["subtitlesScoreCount"] || 0
  );
  const [userScore, setUserScore] = React.useState({ scored: false, score: 0 });
  const [comments, setComments] = React.useState({ docs: [] });
  const [errorComment, setErrorComment] = React.useState("");
  const [disableSendComment, setDisableSendComment] = React.useState(false);
  const [commentData, setCommentData] = React.useState({
    name: "",
    subtitlesId: "",
    comment: "",
  });
  const [controlAlert, setControlAlert] = React.useState({
    open: true,
    message: "لطفا صبر کنید",
    severity: "warning",
    SkeletonDisplay: "none",
  });
  const [pageAndPerPage, setPageAndPerPage] = React.useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
  });

  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getCommentsFromBack(
      "getSubtitlesCommentsApi",
      { subtitlesId: oneRowSubtitle[0]["_id"] },
      PageAndPerPageValue
    );
  };

  const handleCommentData = (type, value) => {
    const newValue = {};
    newValue["subtitlesId"] = oneRowSubtitle[0]["_id"];
    if (type == "name") newValue["name"] = value;
    else if (type == "comment") newValue["comment"] = value;
    else if (type == "replyCommentId") newValue["replyCommentId"] = value;
    setCommentData({ ...commentData, ...newValue });
  };

  const getCommentsFromBack = async (request, data, paginateData = {}) => {
    setControlAlert({
      open: true,
      message: "لطفا صبر کنید",
      severity: "warning",
      SkeletonDisplay: "Block",
    });
    setComments({ docs: [] });
    let paginate = { ...pageAndPerPage, ...paginateData };
    if (request == "getSubtitlesCommentsApi") {
      let received = await getSubtitlesCommentsApi(data, paginate);
      // let received = fetchedSubtitlesListSample;
      if (received.data.success) {
        setComments(received["data"]["data"]);
        setControlAlert({
          open: false,
          message: "جواب آمد",
          severity: "warning",
          SkeletonDisplay: "none",
        });
        const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
          received["data"]["data"];
        const newValues = {
          totalPages,
          hasNextPage,
          hasPrevPage,
          page,
          totalDocs,
        };
        setPageAndPerPage({
          ...pageAndPerPage,
          ...paginateData,
          ...newValues,
        });
      } else {
        setControlAlert({
          open: true,
          message: "مشکلی پیش آمده است",
          severity: "warning",
          SkeletonDisplay: "none",
        });
      }
    }
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
    if (!expanded)
      getCommentsFromBack("getSubtitlesCommentsApi", {
        subtitlesId: oneRowSubtitle[0]["_id"],
      });
  };

  const handleUserScore = async (event, newValue) => {
    setUserScore({ scored: true, score: newValue });
    await scoreSubtitlesApi({
      subId: oneRowSubtitle[0]["_id"],
      scoreValue: newValue,
    });
    let totalScore =
      (subtitlesScoreCount * subtitlesScoreValue +
        (newValue - userScore["score"])) /
      (subtitlesScoreCount + !userScore["scored"]);
    if (!userScore.scored) setSubtitlesScoreCount(subtitlesScoreCount + 1);
    setSubtitlesScoreValue(totalScore);
  };

  const handleSendComment = async () => {
    setDisableSendComment(true);
    if (!commentData.name || !commentData.comment) {
      setErrorComment("لطفا  نام و متن  نظر را وارد کنید");
      setDisableSendComment(false);
    } else {
      let res = await addCommemtApi(commentData);
      if (res["data"]["success"]) {
        setErrorComment("نظر شما با موفقیت ارسال شد");
        await getCommentsFromBack("getSubtitlesCommentsApi", {
          subtitlesId: oneRowSubtitle[0]["_id"],
        });
      }
      setDisableSendComment(false);

      // comments, setComments] = React.useState({ docs: []
      // console.log("res", res["data"]["data"]["data"]);
    }
  };
  return (
    <Card sx={{ width: 300, textAlign: "start" }}>
      <CardHeader
        // sx={{  }}
        avatar={
          <Avatar aria-label="recipe">
            {oneRowSubtitle[0]["subtitlesLanguage"] || ""}
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title={oneRowSubtitle[0]["nameOfMovie"] || ""}
        subheader={
          oneRowSubtitle[0]["episode"]
            ? `فصل ${oneRowSubtitle[0]["episode"]} قسمت ${oneRowSubtitle[0]["season"]}`
            : ""
        }
      />
      <CardMedia
        component="img"
        height="194"
        // image={require("../../../../../1.png")}
        alt="Paella dish"
      />
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          زبان زیر نویس :{" "}
          {`${languagesList[oneRowSubtitle[0]["subtitlesLanguage"]] || ""}`}
          <br />
          تست
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        {/* <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton>
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton> */}
        <Typography sx={{ color: "#938e93" }}>
          {`(${subtitlesScoreCount})`}
        </Typography>
        <Rating
          name="half-rating-read"
          value={subtitlesScoreValue}
          precision={0.5}
          readOnly
        />
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {controlAlert.open ? (
          <Box>
            <Collapse in={controlAlert.open}>
              <Alert
                severity={controlAlert.severity}
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setControlAlert({
                        open: false,
                        message: "",
                        severity: "info",
                        SkeletonDisplay: "none",
                      });
                    }}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                {controlAlert.message}
              </Alert>
            </Collapse>
            <Stack sx={{ display: controlAlert.SkeletonDisplay }} spacing={1}>
              <Skeleton />
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
            </Stack>
          </Box>
        ) : (
          <CardContent>
            <CardActions disableSpacing sx={{ my: 2 }}>
              <TextField
                onChange={(e) => {
                  handleCommentData("name", e.target.value);
                }}
                fullWidth
                multiline
                label="نام"
                color="secondary"
                size="small"
                inputProps={{ maxLength: 40 }}
                sx={{ mr: 1 }}
              />
              امتیاز:
              <Rating
                name="half-rating"
                value={userScore.score}
                onChange={handleUserScore}
                precision={0.5}
              />
            </CardActions>
            <TextField
              onChange={(e) => {
                handleCommentData("comment", e.target.value);
              }}
              fullWidth
              multiline
              label="نظر شما"
              color="secondary"
              focused
              inputProps={{ maxLength: 350 }}
            />
            <Typography sx={{ color: "red" }}>{errorComment || ""}</Typography>
            <Button
              disabled={disableSendComment}
              onClick={handleSendComment}
              variant="contained"
              endIcon={<SendIcon />}
              sx={{ my: 1 }}
            >
              ارسال نظر
            </Button>
            {/* <Typography paragraph>Method:</Typography> */}
            <Pagination
              count={pageAndPerPage.totalPages}
              siblingCount={0}
              // hideNextButton={pageAndPerPage.hasNextPage}
              // hidePrevButton={pageAndPerPage.hasPrevPage}
              // totalPages:0,
              // hasNextPage:false,
              // hasPrevPage:false,
              page={pageAndPerPage.page}
              // totalDocs:0,
              // totalPages: 0

              onChange={(e, value) => {
                setNumberPageAndPerPage("page", value);
              }}
              variant="outlined"
              shape="rounded"
              size="small"
            />
            <Divider />

            {comments["docs"].map((el, index) => (
              <Box key={`Box-${index}`}>
                <Divider textAlign="left">{el.name}:</Divider>
                <Typography align="justify" paragraph>
                  {el.comment}
                </Typography>
              </Box>
            ))}

            {/* <Divider textAlign="right">RIGHT</Divider>
            <Typography paragraph>
              Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet
              over medium-high heat. Add chicken, shrimp and chorizo, and cook,
              stirring occasionally until lightly browned, 6 to 8 minutes.
              Transfer shrimp to a large plate and set aside, leaving chicken
              and chorizo in the pan. Add pimentón, bay leaves, garlic,
              tomatoes, onion, salt and pepper, and cook, stirring often until
              thickened and fragrant, about 10 minutes. Add saffron broth and
              remaining 4 1/2 cups chicken broth; bring to a boil.
            </Typography>
            <Divider textAlign="right">RIGHT</Divider>
            <Typography paragraph>
              Add rice and stir very gently to distribute. Top with artichokes
              and peppers, and cook without stirring, until most of the liquid
              is absorbed, 15 to 18 minutes. Reduce heat to medium-low, add
              reserved shrimp and mussels, tucking them down into the rice, and
              cook again without stirring, until mussels have opened and rice is
              just tender, 5 to 7 minutes more. (Discard any mussels that
              don&apos;t open.)
            </Typography>
            <Typography>
              Set aside off of the heat to let rest for 10 minutes, and then
              serve.
            </Typography> */}
          </CardContent>
        )}
      </Collapse>
    </Card>
  );
}

const languagesList = {
  ab: "Abkhazian",
  aa: "Afar",
  af: "Afrikaans",
  ak: "Akan",
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  an: "Aragonese",
  hy: "Armenian",
  as: "Assamese",
  av: "Avaric",
  ae: "Avestan",
  ay: "Aymara",
  az: "Azerbaijani",
  bm: "Bambara",
  ba: "Bashkir",
  eu: "Basque",
  be: "Belarusian",
  bn: "Bengali",
  bh: "Bihari languages",
  bi: "Bislama",
  bs: "Bosnian",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan, Valencian",
  km: "Central Khmer",
  ch: "Chamorro",
  ce: "Chechen",
  ny: "Chichewa, Chewa, Nyanja",
  zh: "Chinese",
  cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
  cv: "Chuvash",
  kw: "Cornish",
  co: "Corsican",
  cr: "Cree",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  dv: "Divehi, Dhivehi, Maldivian",
  nl: "Dutch, Flemish",
  dz: "Dzongkha",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  ee: "Ewe",
  fo: "Faroese",
  fj: "Fijian",
  fi: "Finnish",
  fr: "French",
  ff: "Fulah",
  gd: "Gaelic, Scottish Gaelic",
  gl: "Galician",
  lg: "Ganda",
  ka: "Georgian",
  de: "German",
  ki: "Gikuyu, Kikuyu",
  el: "Greek (Modern)",
  kl: "Greenlandic, Kalaallisut",
  gn: "Guarani",
  gu: "Gujarati",
  ht: "Haitian, Haitian Creole",
  ha: "Hausa",
  he: "Hebrew",
  hz: "Herero",
  hi: "Hindi",
  ho: "Hiri Motu",
  hu: "Hungarian",
  is: "Icelandic",
  io: "Ido",
  ig: "Igbo",
  id: "Indonesian",
  ia: "Interlingua (International Auxiliary Language Association)",
  ie: "Interlingue",
  iu: "Inuktitut",
  ik: "Inupiaq",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  jv: "Javanese",
  kn: "Kannada",
  kr: "Kanuri",
  ks: "Kashmiri",
  kk: "Kazakh",
  rw: "Kinyarwanda",
  kv: "Komi",
  kg: "Kongo",
  ko: "Korean",
  kj: "Kwanyama, Kuanyama",
  ku: "Kurdish",
  ky: "Kyrgyz",
  lo: "Lao",
  la: "Latin",
  lv: "Latvian",
  lb: "Letzeburgesch, Luxembourgish",
  li: "Limburgish, Limburgan, Limburger",
  ln: "Lingala",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  mk: "Macedonian",
  mg: "Malagasy",
  ms: "Malay",
  ml: "Malayalam",
  mt: "Maltese",
  gv: "Manx",
  mi: "Maori",
  mr: "Marathi",
  mh: "Marshallese",
  ro: "Moldovan, Moldavian, Romanian",
  mn: "Mongolian",
  na: "Nauru",
  nv: "Navajo, Navaho",
  nd: "Northern Ndebele",
  ng: "Ndonga",
  ne: "Nepali",
  se: "Northern Sami",
  no: "Norwegian",
  nb: "Norwegian Bokmål",
  nn: "Norwegian Nynorsk",
  ii: "Nuosu, Sichuan Yi",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  or: "Oriya",
  om: "Oromo",
  os: "Ossetian, Ossetic",
  pi: "Pali",
  pa: "Panjabi, Punjabi",
  ps: "Pashto, Pushto",
  fa: "Persian",
  pl: "Polish",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ru: "Russian",
  sm: "Samoan",
  sg: "Sango",
  sa: "Sanskrit",
  sc: "Sardinian",
  sr: "Serbian",
  sn: "Shona",
  sd: "Sindhi",
  si: "Sinhala, Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  st: "Sotho, Southern",
  nr: "South Ndebele",
  es: "Spanish, Castilian",
  su: "Sundanese",
  sw: "Swahili",
  ss: "Swati",
  sv: "Swedish",
  tl: "Tagalog",
  ty: "Tahitian",
  tg: "Tajik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  bo: "Tibetan",
  ti: "Tigrinya",
  to: "Tonga (Tonga Islands)",
  ts: "Tsonga",
  tn: "Tswana",
  tr: "Turkish",
  tk: "Turkmen",
  tw: "Twi",
  ug: "Uighur, Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volap_k",
  wa: "Walloon",
  cy: "Welsh",
  fy: "Western Frisian",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang, Chuang",
  zu: "Zulu",
};
